import { Box, makeStyles, styled } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';

export const LearnMoreContainer = styled(Box)(({ theme }) => ({
  marginTop: '5px',
  backgroundColor: theme.palette.type === 'dark' ? COLORS.WARNING_BG : COLORS.LIGHT_BACKGROUND,
  border: theme.palette.type === 'dark' ? `1px solid ${COLORS.WARNING_BORDER}` : `2px solid ${COLORS.WARNING_BORDER}`,
  borderRadius: '5px',
  padding: '10px 15px',
  height: 'fit-content',
  [theme.breakpoints.up('md')]: {
    maxWidth: '50%',
    height: 'fit-content',
  },
}));

export const useStyles = makeStyles((theme) => ({
  tooltip: {
    backgroundColor: (theme.palette.type === 'dark' ? COLORS.WARNING_BG : COLORS.LIGHT_BACKGROUND) + '!important',
    border:
      (theme.palette.type === 'dark' ? `1px solid ${COLORS.WARNING_BORDER}` : `2px solid ${COLORS.WARNING_BORDER}`) +
      '!important',
  },
}));
